import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import { MAFIA_ACCESS_ERROR } from '../../types/errors';
const ErrBackground = styled.div `
  height: 100vh;
  background-color: #282b24;
`;
const ErrContainer = styled.div `
  text-align: center;
  margin: 0;
  color: #f1eedb;
`;
export function Login() {
    return (_jsx(ErrBackground, { children: _jsxs(ErrContainer, { children: [_jsx(Typography, Object.assign({ variant: "h1" }, { children: MAFIA_ACCESS_ERROR })), _jsx(Typography, Object.assign({ variant: "h2" }, { children: "Access Forbidden" }))] }) }));
}
